import { queriesClient } from '@app/api2/Clients';
import { FormikWithSchema } from '@app/components/React/Common/Forms/FormikWithSchema';
import { ChangeObserver } from '@app/components/React/Labs/ChangeObserver';
import { FieldArray, Formik, useFormikContext } from 'formik';
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import * as Yup from 'yup';
import { Form as SForm, Divider, Dropdown, Table, Input, Segment, TableHeader, TableHeaderCell, TableBody, TableRow, TableCell, Button, Icon, Container } from 'semantic-ui-react';
import SemanticFormikInput from '@app/components/React/Common/Forms/SemanticFormikInput';
import './AlleleTableForm.less';
import SemanticFormikSelect from '@app/components/React/Common/Forms/SemanticFormikSelect';


type AlleleTableProps = {
  // kitId?: number;
  // markers: AlleleTableMarkerDto[];
  value: AlleleTableMarkers;
  onChange?: (values: AlleleTableMarkers) => void;
};


type AlleleTableMarkers = {
  kitId?: number;
  systems: AlleleTableMarkerDto[];
};

type AlleleTableMarkerDto = {
  name?: string;
  allele1?: string;
  allele2?: string;
};

export const AlleleTableFormSchema: Yup.SchemaOf<AlleleTableMarkers> = Yup.object({
  kitId: Yup.number().optional(),
  systems: Yup.array().of(Yup.object({
    name: Yup.string().required('Marker name is required'),
    allele1: Yup.string().required('Allele 1 is required'),
    allele2: Yup.string().required('Allele 2 is required'),
  })).required(),
});

export const AlleleTableForm: React.FC<AlleleTableProps> = ({ value, onChange }) => {
  // console.log('AlleleTableForm markers:', value.markers);
    const markers = useQuery({
        queryKey: ['distinctMarkers'],
        queryFn: async () => {
            var data = await queriesClient.getDistinctMarkers();
            return data;
        },
    });

  let m = value?.systems ?? [{ name: '', allele1: '', allele2: '' }]
  if (m.length === 0) {
    m = [{ name: '', allele1: '', allele2: '' }];
  }
  const initialValues: AlleleTableMarkers = {
    kitId: value?.kitId,
    systems: m,
  };
  

  return (
    <FormikWithSchema
      initialValues={initialValues}
      validationSchema={AlleleTableFormSchema}
      validateOnBlur={false}
      onSubmit={() => { }}
      validateOnChange={false}
      enableReinitialize
    >
      {({ handleSubmit, values, setFieldValue }) => (
        <>
          <ChangeObserver value={values} onChange={onChange} />

          <FieldArray name={'systems'}>
            {({ push, remove, insert, form }) => {
              return (
                <>
                  <Table collapsing className='allele-table-form-table'>
                    <TableHeader>
                      <TableRow>
                        <TableHeaderCell collapsing>Marker Name</TableHeaderCell>
                        <TableHeaderCell collapsing>Allele 1</TableHeaderCell>
                        <TableHeaderCell collapsing>Allele 2</TableHeaderCell>
                        <TableHeaderCell></TableHeaderCell>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {form.values?.systems?.map((item, idx) => (

                        <TableRow key={idx}>
                          <TableCell>
                            {/* <SemanticFormikInput autoComplete='off' name={`systems.${idx}.name`} placeholder='AMEL' /> */}
                            <SemanticFormikSelect name={`systems.${idx}.name`} myAllowAdditions options={markers?.data?.systems?.map((marker) => ({ key: marker.name, text: marker.name, value: marker.name })) ?? []} />
                          </TableCell>
                          <TableCell>
                            <SemanticFormikInput name={`systems.${idx}.allele1`} placeholder='X' />
                          </TableCell>
                          <TableCell>
                            <SemanticFormikInput name={`systems.${idx}.allele2`} placeholder='Y' />
                          </TableCell>
                          <TableCell>
                            <Button
                              compact
                              size='tiny'
                              type="button"
                              icon
                              onClick={() => {
                                const newItem = { name: '', allele1: '', allele2: '' };
                                insert(idx + 1, newItem);
                                // push(newItem);
                                // onChange?.(newItem);
                              }}
                            >
                              <Icon name="plus" />
                            </Button>
                            <Button
                              size='tiny'
                              negative
                              compact
                              icon
                              disabled={form.values.systems.length <= 1}
                              type="button"
                              onClick={() => {
                                remove(idx);
                              }}
                            >
                              <Icon name="minus" />
                            </Button>
                          </TableCell>
                        </TableRow>
                        // <RemovableSegment disabled={disabled} key={idx} remove={() => {
                        //     remove(idx);
                        //     onChange?.(item);
                        // } }>
                        //     {children({ form, remove, item: item, idx })}
                        // </RemovableSegment>
                      ))}
                      {/* {!disabled && (maxItems == undefined || form.values[name].length < maxItems) && <Button
                            icon
                            labelPosition="left"
                            color="green"
                            type="button"
                            onClick={() => {
                                const newItem = newItemFactory();
                                push(newItem);
                                onChange?.(newItem);
                            } }
                            disabled={disabled || (maxItems !== undefined && form.values[name].length >= maxItems)}>
                            <Icon name="plus" />
                            {addButtonLabel}
                        </Button>} */}
                    </TableBody>
                  </Table>
                </>
              );
            }}
          </FieldArray>

          {/* <DnaFormFields /> */}



        </>
      )}
    </FormikWithSchema>
  );
};

function DnaFormFields() {
  const { values, setFieldValue } = useFormikContext<AlleleTableMarkers>();

  const kits = useQuery({
    queryKey: ['allKits'],
    queryFn: async () => {
      return await queriesClient.getKits();
    }
  });

  const markers = useQuery({
    queryKey: ['kitMarkers', values.kitId],
    queryFn: async () => {
      return await queriesClient.getKitMarkers(values.kitId!);
    },
    enabled: !!values.kitId,
    // onSuccess: (data) => {
    //   const initialMarkers: AlleleTableMarkerDto[] = [];
    //   data.systems.forEach(marker => {
    //     initialMarkers.push({ allele1: '', allele2: '', name: marker.name } as AlleleTableMarkerDto);
    //   });
    //   setFieldValue('markers', [...initialMarkers, ...(values.systems || [])]);

    // }
  });

    React.useEffect(() => {
      const initialMarkers: AlleleTableMarkerDto[] = [];
      markers.data.systems.forEach(marker => {
        initialMarkers.push({ allele1: '', allele2: '', name: marker.name } as AlleleTableMarkerDto);
      });
      setFieldValue('markers', [...initialMarkers, ...(values.systems || [])]);
    }, [markers.data])

  return (
    <>

      <SForm.Field>
        <label>Loci Order *</label>
        <Dropdown
          placeholder="Kit"
          fluid
          selectOnNavigation={false}
          search
          selection
          value={values.kitId}
          options={kits.data?.map(kit => ({ key: `kit_${kit.id}`, text: kit.fullName, value: kit.id })) || []}
          onChange={(e, { value }) => {
            setFieldValue('kitId', value as number);
          }}
        />
      </SForm.Field>

      <Segment loading={markers.isLoading} style={{ marginTop: '1rem', maxHeight: '400px', overflowY: 'auto' }}>
        <Table celled compact>
          <TableHeader>
            <Table.Row>
              <TableHeaderCell width={4}>System</TableHeaderCell>
              <TableHeaderCell width={6}>Allele 1</TableHeaderCell>
              <TableHeaderCell width={6}>Allele 2</TableHeaderCell>
            </Table.Row>
          </TableHeader>
          <Table.Body>
            {values.systems && 'map' in values.systems && values.systems.map((marker, index) => (
              <Table.Row key={index}>
                <Table.Cell><strong>{marker.name}</strong></Table.Cell>
                <Table.Cell>
                  <Input
                    value={marker.allele1 || ''}
                    onChange={(e) => {
                      const newMarkers = [...values.systems];
                      newMarkers[index] = { ...newMarkers[index], allele1: (e.target as HTMLInputElement).value };
                      setFieldValue('markers', newMarkers);
                    }}
                    transparent
                    fluid
                  />
                </Table.Cell>
                <Table.Cell>
                  <Input
                    value={marker.allele2 || ''}
                    onChange={(e) => {
                      const newMarkers = [...values.systems];
                      newMarkers[index] = { ...newMarkers[index], allele2: (e.target as HTMLInputElement).value };
                      setFieldValue('markers', newMarkers);
                    }}
                    transparent
                    fluid
                  />
                </Table.Cell>
                <Table.Cell>
                  <Input
                    value={marker.allele2 || ''}
                    onChange={(e) => {
                      const newMarkers = [...values.systems];
                      newMarkers[index] = { ...newMarkers[index], allele2: (e.target as HTMLInputElement).value };
                      setFieldValue('markers', newMarkers);
                    }}
                    transparent
                    fluid
                  />
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Segment>
    </>
  );
}